import { ModuleIOValueTypeEnum, ModuleInputKeyEnum, ModuleTemplateTypeEnum } from '../../constants';
import { FlowNodeInputTypeEnum, FlowNodeTypeEnum } from '../../node/constants';
import { FlowModuleTemplateType } from '../../types';
import { Input_Template_Switch } from '../input';
import { Output_Template_Finish } from '../output';

export const AssignedAnswerModule: FlowModuleTemplateType = {
  id: FlowNodeTypeEnum.assignedAnswerNode,
  templateType: ModuleTemplateTypeEnum.logicDeal,
  flowType: FlowNodeTypeEnum.assignedAnswerNode,
  avatar: '/imgs/module/reply.png',
  name: '指定回复',
  description:
    '该模块可以直接回复一段指定的内容。常用于引导、提示。非字符串内容传入时，会转成字符串进行输出。',
  inputs: [
    Input_Template_Switch,
    {
      key: ModuleInputKeyEnum.answer,
      type: FlowNodeInputTypeEnum.textarea,
      valueType: ModuleIOValueTypeEnum.any,
      label: '回复的内容',
      description: `可以使用 \\n 来实现连续换行。
可以通过外部模块输入实现回复，外部模块输入时会覆盖当前填写的内容。
如传入非字符串类型数据将会自动转成字符串`,
      placeholder: `可以使用 \\n 来实现连续换行。
可以通过外部模块输入实现回复，外部模块输入时会覆盖当前填写的内容。
如传入非字符串类型数据将会自动转成字符串`,
      showTargetInApp: true,
      showTargetInPlugin: true,
    },
  ],
  outputs: [Output_Template_Finish],
};
